import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

function SignOutPage({ logoutAll }) {
  const navigate = useNavigate();

  useEffect(() => {
    const url = logoutAll ? 'logout-all' : 'logout';
    const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
    fetch(process.env.REACT_APP_API_URL + url, {
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": token
      }
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }

        throw new Error(response);
      })
      .then((responseData) => {
        localStorage.clear();
        navigate('/', { replace: true });
      })
      .catch(function (error) {
        console.log('There has been a problem with your fetch operation: ',
          error.message);
      });
  }, [logoutAll]);

  return (<></>);
}
SignOutPage.defaultProps = {
  logoutAll: false,
};

SignOutPage.propTypes = {
  logoutAll: PropTypes.bool,
};

export default SignOutPage;
